import React from 'react';
import { FiThumbsUp, FiThumbsDown } from 'react-icons/fi';

export default function FeedbackCard({ data, onGiveFeedback }) {
  return (
    <div className="bg-white/90 dark:bg-gray-800/90 p-6 rounded-xl shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">🔍 AI Feedback</h2>
      <ul className="space-y-2 text-gray-700 dark:text-gray-300">
        <li><strong>Score:</strong> {data.score} / 5</li>
        <li><strong>Summary:</strong> {data.summary}</li>
        <li><strong>Suggestion:</strong> {data.suggestion}</li>
      </ul>

      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4">
        <button
          onClick={() => onGiveFeedback(true)}
          disabled={data.submitted}
          className="flex items-center px-4 py-2 bg-green-50 hover:bg-green-100 dark:bg-green-900/50 dark:hover:bg-green-800 
                     text-green-700 dark:text-green-300 rounded-lg transition disabled:opacity-50 w-full sm:w-auto justify-center"
        >
          <FiThumbsUp className="mr-2" /> Helpful
        </button>
        <button
          onClick={() => onGiveFeedback(false)}
          disabled={data.submitted}
          className="flex items-center px-4 py-2 bg-red-50 hover:bg-red-100 dark:bg-red-900/50 dark:hover:bg-red-800 
                     text-red-700 dark:text-red-300 rounded-lg transition disabled:opacity-50 w-full sm:w-auto justify-center"
        >
          <FiThumbsDown className="mr-2" /> Not Helpful
        </button>
        {data.submitted && (
          <span className="text-sm text-gray-500 dark:text-gray-400 mt-2 sm:mt-0">
            You marked this as {data.helpful ? 'helpful 👍' : 'not helpful 👎'}.
          </span>
        )}
      </div>
    </div>
  );
}
